import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { AppConfig } from '@tmhcc-ng-lib/models';
import { Observable } from 'rxjs/internal/Observable';
import { HttpOptions } from '@tmhcc-ng-lib/framwork/http';
import { IsTrue } from 'libs/util/binary-util';
import { GlobalVariablesService } from './global-variables.service';

export abstract class BaseDataService {
  protected config: AppConfig;
  protected serviceBaseUrl: string;

  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    this.config = configService.config;
    this.serviceBaseUrl = this.config.dataServiceBaseUrl;
  }

  protected get<T>(
    url: string,
    options?: HttpOptions,
    appendUserIdInHeader = false,
    appendInfinityKey = false,
    appendSessionID = true
  ): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendHeaders(
      options.headers,
      appendUserIdInHeader,
      appendInfinityKey,
      appendSessionID
    );

    return this.http.get<T>(url, options);
  }

  protected post<T>(
    url: string,
    options?: HttpOptions,
    appendUserIdInHeader = false,
    appendSessionID = true
  ): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendHeaders(
      options.headers,
      appendUserIdInHeader,
      false,
      appendSessionID
    );

    return this.http.post<T>(url, options.body, {
      params: options.params,
      headers: options.headers
    });
  }

  protected put<T>(
    url: string,
    options?: HttpOptions,
    appendUserIdInHeader = false,
    appendSessionID = true
  ): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendHeaders(
      options.headers,
      appendUserIdInHeader,
      false,
      appendSessionID
    );

    return this.http.put<T>(url, options.body, {
      params: options.params,
      headers: options.headers
    });
  }

  private appendHeaders(
    headers?: HttpHeaders,
    appendUserId?: boolean,
    appendInfinity?: boolean,
    appendSessionID?: boolean
  ): HttpHeaders {
    if (!headers) {
      headers = new HttpHeaders();
    }

    headers = headers
      //.set('x-api-key', this.config.dataServiceApiKey)
      .set('content-type', 'application/json');

    if (appendUserId === true) {
      headers = headers.set(
        'UserEmail',
        sessionStorage.getItem('UserId') || ''
      );
    }

    if (IsTrue(this.config.dataServiceSessionId) && appendSessionID) {
      headers = headers.set('session-id', this.globalVariables.sessionId);
    }

    return headers;
  }
}
